import { useContext } from 'react';

import { PortalContext } from '../../../context/PortalContext';
import { LAWW_USER_TIER2 } from '../../Constants';
import { isLawwMember } from '../../Utils/memberUtils/memberUtils';

const isTier2User = (userTier?: string) => userTier === LAWW_USER_TIER2;

export const viewCostEstimate = (
  costEstimateLink: string,
  portalName: string,
  initiateViewEstimate: boolean,
  isGuestUser: boolean,
  basePath: string,
  enableCEX: boolean,
  enableCostEstimateInCurrentTab: boolean,
  userTier?: string,
  signInUrl?: string,
  carePathStepId?: string,
  legacySSOUrl?: string
) => {
  if (isGuestUser && signInUrl) {
    const carePathIdParam = carePathStepId
      ? `&carePathId=${carePathStepId}`
      : '';
    const carePathStepIdParam = carePathStepId
      ? `&carePathStepId=${carePathStepId}_1`
      : '';
    const callBackUrl = `${window.location.pathname}${window.location.search}${carePathIdParam}${carePathStepIdParam}&initiateViewEstimate=${initiateViewEstimate}`;
    const newSignInUrl = new URL(
      signInUrl.replace('LANDING_PAGE', callBackUrl),
      window.location.origin
    ).href;

    window.open(newSignInUrl, '_self');
  } else if (
    isLawwMember(portalName) &&
    isTier2User(userTier) &&
    legacySSOUrl
  ) {
    if (enableCEX) {
      const newCEXUrl = new URL(
        basePath.replace('/provider-search', costEstimateLink),
        window.location.origin
      ).href;
      window.open(newCEXUrl, '_self');
    } else {
      const SSOUrl = legacySSOUrl.replace(
        'FPC_URL',
        encodeURIComponent(costEstimateLink)
      );
      const newSSOUrl = new URL(
        basePath.replace('/provider-search', SSOUrl),
        window.location.origin
      ).href;
      window.open(newSSOUrl, '_blank');
    }
  } else {
    window.open(
      costEstimateLink,
      enableCostEstimateInCurrentTab ? '_self' : '_blank'
    );
  }
};

export const usePortalCostEstimate = (
  enableCEX: boolean,
  enableCostEstimateInCurrentTab: boolean,
  locale?: string
) => {
  const { portalData } = useContext(PortalContext);
  const isGuestUser = portalData?.portalConfig?.isGuestUser ?? false;
  const signInUrl = portalData?.portalConfig?.signInUrl;
  const userTier = portalData?.portalConfig?.userTier;

  const getCostEstimateLink = (enableCEXFlag: boolean): string => {
    const base = `${enableCEXFlag ? '/costestimate' : '/care'}`;
    return locale ? `${base}?locale=${locale}` : base;
  };

  const handleViewCostEstimate = (carePath?: any) => {
    viewCostEstimate(
      getCostEstimateLink(enableCEX),
      portalData?.portalName,
      true,
      isGuestUser,
      portalData?.portalConfig?.basePath,
      enableCEX,
      enableCostEstimateInCurrentTab,
      userTier,
      signInUrl,
      carePath?.carePathIdentifier,
      portalData?.portalConfig?.legacySSOUrl
    );
  };

  return { handleViewCostEstimate };
};